(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giesto-arket-promotions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.GiestoCategoryPromosMore) return;
    window.GiestoCategoryPromosMore = true;

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const button = target.closest('[data-ga-category-promos-more]');
      if (!(button instanceof HTMLButtonElement)) return;

      const promos = button.closest('[data-ga-category-promos]');
      if (!(promos instanceof HTMLElement)) return;

      const expanded = promos.dataset.expanded !== 'true';
      promos.dataset.expanded = String(expanded);
      button.setAttribute('aria-expanded', String(expanded));

      const label = button.querySelector('[data-ga-category-promos-more-label]');
      const text = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      if (label && text) label.textContent = text;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('giesto-site-header')) {
    class GiestoSiteHeader extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.controller = new AbortController();
        this.drawer = this.querySelector('[data-giesto-header-drawer]');
        this.backdrop = this.querySelector('[data-giesto-header-backdrop]');
        this.announcement = this.querySelector('.giesto-header__announcement');
        this.drawerPanels = Array.from(this.querySelectorAll('[data-giesto-header-drawer-panel]'));
        this.openTriggers = Array.from(this.querySelectorAll('[data-giesto-header-open]'));
        this.mega = this.querySelector('[data-giesto-header-mega]');
        this.megaPanels = Array.from(this.querySelectorAll('[data-giesto-header-mega-panel]'));
        this.megaSurfaces = Array.from(this.querySelectorAll('[data-giesto-header-mega-panel]'));
        this.megaTriggers = Array.from(this.querySelectorAll('[data-giesto-header-mega-open]'));
        this.primaryNavigation = this.querySelector('.giesto-header__primary-navigation');
        this.primaryTriggers = Array.from(this.primaryNavigation?.querySelectorAll('.giesto-header__primary-trigger') || []);
        // Titles that open a mega panel are links too now, but they are not
        // "plain" links - a plain link CLOSES the panel on hover, which would
        // fight the trigger that just opened it.
        this.primaryPlainLinks = Array.from(
          this.primaryNavigation?.querySelectorAll(
            'a.giesto-header__primary-trigger:not([data-giesto-header-mega-open])'
          ) || []
        );
        this.defaultMegaTrigger = this.primaryTriggers.find((trigger) => trigger.getAttribute('aria-current') === 'page')
          || this.primaryTriggers.find((trigger) => trigger.hasAttribute('data-giesto-header-mega-default'))
          || this.megaTriggers[0]
          || this.primaryTriggers[0]
          || null;
        this.megaCategoryTriggers = Array.from(this.querySelectorAll('[data-giesto-header-mega-category-trigger]'));
        this.megaCategoryPanels = Array.from(this.querySelectorAll('[data-giesto-header-mega-category-panel]'));
        this.megaCloseButtons = Array.from(this.querySelectorAll('[data-giesto-header-mega-close]'));
        this.mobilePanels = Array.from(this.querySelectorAll('[data-giesto-header-mobile-panel]'));
        this.mobilePanelTriggers = Array.from(this.querySelectorAll('[data-giesto-header-mobile-open]'));
        this.mobileBackButtons = Array.from(this.querySelectorAll('[data-giesto-header-mobile-back]'));
        this.localeDialog = this.querySelector('[data-giesto-header-locale-dialog]');
        this.localeTriggers = Array.from(this.querySelectorAll('[data-giesto-header-locale-open]'));
        this.localeCloseButtons = Array.from(this.querySelectorAll('[data-giesto-header-locale-close]'));
        this.searchPanel = this.querySelector('[data-giesto-header-search-panel]');
        this.searchForms = Array.from(this.querySelectorAll('[data-giesto-header-search-form]'));
        this.searchInputs = Array.from(this.querySelectorAll('[data-giesto-header-search-input]'));
        this.searchClearButtons = Array.from(this.querySelectorAll('[data-giesto-header-search-clear]'));
        this.searchCloseButtons = Array.from(this.querySelectorAll('[data-giesto-header-search-close]'));
        this.searchStaticProducts = this.querySelector('[data-giesto-header-search-static-products]');
        this.searchDynamicProducts = this.querySelector('[data-giesto-header-search-dynamic-products]');
        this.searchDynamicResults = this.querySelector('[data-giesto-header-search-dynamic-results]');
        this.predictiveSearchUrl = this.dataset.giestoHeaderPredictiveUrl || '';
        this.predictiveSearchSection = this.dataset.giestoHeaderPredictiveSection || '';
        this.searchFuzzyLabel = this.dataset.giestoHeaderSearchFuzzyLabel || '';
        this.searchCatalogUrl = this.dataset.giestoHeaderSearchCatalogUrl || '';
        this.searchProductsUrl = this.dataset.giestoHeaderProductsUrl || '/products/';
        this.searchCatalogRequest = null;
        this.searchCatalogProducts = null;
        this.desktopMedia = window.matchMedia('(min-width: 990px)');
        this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.megaCloseTimer = null;
        this.activeTrigger = null;
        this.lastTrigger = null;
        this.activeMegaTrigger = null;
        this.lastMegaTrigger = null;
        this.primaryPlainLinkPointer = null;
        this.primaryPlainLinkFocus = null;
        this.lastLocaleTrigger = null;
        this.lastSearchInput = null;
        this.ignoreNextSearchFocus = false;
        this.searchRequestTimer = null;
        this.searchRequestController = null;
        this.searchRequestSequence = 0;

        this.onOpenTrigger = this.onOpenTrigger.bind(this);
        this.onCloseTrigger = this.onCloseTrigger.bind(this);
        this.onCloseLink = this.onCloseLink.bind(this);
        this.onMobilePanelTrigger = this.onMobilePanelTrigger.bind(this);
        this.onMobileBack = this.onMobileBack.bind(this);
        this.onDrawerClose = this.onDrawerClose.bind(this);
        this.onDrawerCancel = this.onDrawerCancel.bind(this);
        this.onDrawerClick = this.onDrawerClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onCartDrawerState = this.onCartDrawerState.bind(this);
        this.onPageHide = this.onPageHide.bind(this);
        this.onPageShow = this.onPageShow.bind(this);
        this.onMegaTrigger = this.onMegaTrigger.bind(this);
        this.onMegaPointerEnter = this.onMegaPointerEnter.bind(this);
        this.onMegaTriggerFocus = this.onMegaTriggerFocus.bind(this);
        this.onMegaPointerLeave = this.onMegaPointerLeave.bind(this);
        this.onPrimaryPlainLinkPointerEnter = this.onPrimaryPlainLinkPointerEnter.bind(this);
        this.onPrimaryPlainLinkPointerLeave = this.onPrimaryPlainLinkPointerLeave.bind(this);
        this.onPrimaryPlainLinkFocus = this.onPrimaryPlainLinkFocus.bind(this);
        this.onPrimaryPlainLinkBlur = this.onPrimaryPlainLinkBlur.bind(this);
        this.onMegaSurfacePointerEnter = this.onMegaSurfacePointerEnter.bind(this);
        this.onMegaSurfacePointerLeave = this.onMegaSurfacePointerLeave.bind(this);
        this.onMegaCategoryTrigger = this.onMegaCategoryTrigger.bind(this);
        this.onMegaClose = this.onMegaClose.bind(this);
        this.onMegaLink = this.onMegaLink.bind(this);
        this.onLocaleOpen = this.onLocaleOpen.bind(this);
        this.onLocaleCloseButton = this.onLocaleCloseButton.bind(this);
        this.onLocaleDialogClose = this.onLocaleDialogClose.bind(this);
        this.onLocaleDialogCancel = this.onLocaleDialogCancel.bind(this);
        this.onLocaleDialogClick = this.onLocaleDialogClick.bind(this);
        this.onSearchInput = this.onSearchInput.bind(this);
        this.onSearchFocus = this.onSearchFocus.bind(this);
        this.onSearchSubmit = this.onSearchSubmit.bind(this);
        this.onSearchSubmitClick = this.onSearchSubmitClick.bind(this);
        this.onSearchClear = this.onSearchClear.bind(this);
        this.onSearchClose = this.onSearchClose.bind(this);
        this.onSearchLink = this.onSearchLink.bind(this);
        this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
        this.onBreakpointChange = this.onBreakpointChange.bind(this);

        /* A bfcache/theme-editor remount can preserve an old open attribute. */
        this.resetDrawerState();
        this.resetMegaState();
        this.resetMobilePanelState();
        this.resetSearchState();
        this.resetLocaleState();

        this.openTriggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onOpenTrigger, { signal: this.controller.signal });
        });

        this.mobilePanelTriggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onMobilePanelTrigger, { signal: this.controller.signal });
        });

        this.mobileBackButtons.forEach((button) => {
          button.addEventListener('click', this.onMobileBack, { signal: this.controller.signal });
        });

        this.megaTriggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onMegaTrigger, { signal: this.controller.signal });
          trigger.addEventListener('pointerenter', this.onMegaPointerEnter, { signal: this.controller.signal });
          trigger.addEventListener('pointerleave', this.onMegaPointerLeave, { signal: this.controller.signal });
          trigger.addEventListener('focus', this.onMegaTriggerFocus, { signal: this.controller.signal });
        });

        this.primaryPlainLinks.forEach((link) => {
          link.addEventListener('pointerenter', this.onPrimaryPlainLinkPointerEnter, { signal: this.controller.signal });
          link.addEventListener('pointerleave', this.onPrimaryPlainLinkPointerLeave, { signal: this.controller.signal });
          link.addEventListener('focus', this.onPrimaryPlainLinkFocus, { signal: this.controller.signal });
          link.addEventListener('blur', this.onPrimaryPlainLinkBlur, { signal: this.controller.signal });
        });

        this.megaSurfaces.forEach((surface) => {
          surface.addEventListener('pointerenter', this.onMegaSurfacePointerEnter, { signal: this.controller.signal });
          surface.addEventListener('pointerleave', this.onMegaSurfacePointerLeave, { signal: this.controller.signal });
        });

        this.megaCategoryTriggers.forEach((trigger) => {
          trigger.addEventListener('pointerenter', this.onMegaCategoryTrigger, { signal: this.controller.signal });
          trigger.addEventListener('focus', this.onMegaCategoryTrigger, { signal: this.controller.signal });
        });

        this.megaCloseButtons.forEach((button) => {
          button.addEventListener('click', this.onMegaClose, { signal: this.controller.signal });
        });

        this.localeTriggers.forEach((trigger) => {
          trigger.addEventListener('click', this.onLocaleOpen, { signal: this.controller.signal });
        });

        this.localeCloseButtons.forEach((button) => {
          button.addEventListener('click', this.onLocaleCloseButton, { signal: this.controller.signal });
        });

        if (this.localeDialog) {
          this.localeDialog.addEventListener('close', this.onLocaleDialogClose, { signal: this.controller.signal });
          this.localeDialog.addEventListener('cancel', this.onLocaleDialogCancel, { signal: this.controller.signal });
          this.localeDialog.addEventListener('click', this.onLocaleDialogClick, { signal: this.controller.signal });
        }

        this.searchForms.forEach((form) => {
          form.addEventListener('submit', this.onSearchSubmit, { signal: this.controller.signal });
        });

        this.searchInputs.forEach((input) => {
          input.addEventListener('input', this.onSearchInput, { signal: this.controller.signal });
          input.addEventListener('focus', this.onSearchFocus, { signal: this.controller.signal });
          input.addEventListener('click', this.onSearchFocus, { signal: this.controller.signal });
        });

        this.querySelectorAll('[data-giesto-header-search-submit]').forEach((button) => {
          button.addEventListener('click', this.onSearchSubmitClick, { signal: this.controller.signal });
        });

        this.searchClearButtons.forEach((button) => {
          button.addEventListener('click', this.onSearchClear, { signal: this.controller.signal });
        });

        this.searchCloseButtons.forEach((button) => {
          button.addEventListener('click', this.onSearchClose, { signal: this.controller.signal });
        });

        this.querySelectorAll('[data-giesto-header-search-link]').forEach((link) => {
          link.addEventListener('click', this.onSearchLink, { signal: this.controller.signal });
        });

        this.querySelectorAll('[data-giesto-header-mega-link]').forEach((link) => {
          link.addEventListener('click', this.onMegaLink, { signal: this.controller.signal });
        });

        this.querySelectorAll('[data-giesto-header-close]').forEach((trigger) => {
          trigger.addEventListener('click', this.onCloseTrigger, { signal: this.controller.signal });
        });

        this.backdrop?.addEventListener('click', this.onCloseTrigger, { signal: this.controller.signal });

        this.querySelectorAll('[data-giesto-header-close-link]').forEach((link) => {
          link.addEventListener('click', this.onCloseLink, { signal: this.controller.signal });
        });

        if (this.drawer) {
          this.drawer.addEventListener('close', this.onDrawerClose, { signal: this.controller.signal });
          this.drawer.addEventListener('cancel', this.onDrawerCancel, { signal: this.controller.signal });
          this.drawer.addEventListener('click', this.onDrawerClick, { signal: this.controller.signal });
        }

        document.addEventListener('theme-drawer:open', this.onCartDrawerState, { signal: this.controller.signal });
        document.addEventListener('theme-drawer:close', this.onCartDrawerState, { signal: this.controller.signal });
        document.addEventListener('keydown', this.onKeydown, { signal: this.controller.signal });
        document.addEventListener('pointerdown', this.onDocumentPointerDown, { signal: this.controller.signal });
        window.addEventListener('pagehide', this.onPageHide, { signal: this.controller.signal });
        window.addEventListener('pageshow', this.onPageShow, { signal: this.controller.signal });
        this.desktopMedia.addEventListener('change', this.onBreakpointChange, { signal: this.controller.signal });
        this.syncAnnouncementHeight();
        if ('ResizeObserver' in window && this.announcement) {
          this.announcementObserver = new ResizeObserver(() => this.syncAnnouncementHeight());
          this.announcementObserver.observe(this.announcement);
        }
        this.setActivePanel('all');
        this.syncSearchClearButtons();
        this.syncCartDrawerState();
        this.syncHeaderState();
      }

      disconnectedCallback() {
        this.resetDrawerState();
        this.resetMegaState();
        this.resetMobilePanelState();
        this.resetSearchState();
        this.resetLocaleState();
        this.announcementObserver?.disconnect();
        this.announcementObserver = null;
        this.controller?.abort();
      }

      isDesktop() {
        return Boolean(this.desktopMedia?.matches);
      }

      syncAnnouncementHeight() {
        if (this.closest('#header-group')?.hasAttribute('data-condensed')) return;
        const height = Math.max(this.announcement?.offsetHeight || 0, this.announcement?.scrollHeight || 0);
        this.style.setProperty('--giesto-header-announcement-height', `${height}px`);
      }

      onLocaleOpen(event) {
        event.preventDefault();
        if (!this.localeDialog) return;

        this.lastLocaleTrigger = event.currentTarget;
        this.closeSearch(false);
        this.closeMega(false);
        if (this.drawer?.open) this.closeDrawer(false);

        if (!this.localeDialog.open) {
          try {
            this.localeDialog.showModal();
          } catch (error) {
            this.resetLocaleState();
            return;
          }
        }

        this.syncLocaleState();
        window.requestAnimationFrame(() => {
          const selectedOption = this.localeDialog?.querySelector('.giesto-header__locale-option.is-current');
          const closeButton = this.localeDialog?.querySelector('[data-giesto-header-locale-close]');
          (selectedOption || closeButton)?.focus({ preventScroll: true });
        });
      }

      onLocaleDialogClose() {
        const returnFocus = this.localeDialog?.dataset.giestoHeaderLocaleReturnFocus !== 'false';
        if (this.localeDialog) delete this.localeDialog.dataset.giestoHeaderLocaleReturnFocus;
        const trigger = this.lastLocaleTrigger;
        this.lastLocaleTrigger = null;
        this.syncLocaleState();
        if (returnFocus) trigger?.focus({ preventScroll: true });
      }

      onLocaleCloseButton() {
        this.closeLocaleDialog(true);
      }

      onLocaleDialogCancel() {
        if (this.localeDialog) this.localeDialog.dataset.giestoHeaderLocaleReturnFocus = 'true';
      }

      onLocaleDialogClick(event) {
        if (event.target === this.localeDialog) this.closeLocaleDialog(true);
      }

      closeLocaleDialog(returnFocus) {
        if (!this.localeDialog?.open) {
          this.resetLocaleState();
          return;
        }

        this.localeDialog.dataset.giestoHeaderLocaleReturnFocus = returnFocus ? 'true' : 'false';
        this.localeDialog.close();
      }

      resetLocaleState() {
        if (this.localeDialog?.open) {
          this.localeDialog.dataset.giestoHeaderLocaleReturnFocus = 'false';
          this.localeDialog.close();
        }

        this.localeDialog?.removeAttribute('open');
        this.lastLocaleTrigger = null;
        this.localeTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.classList.remove('is-locale-open');
      }

      syncLocaleState() {
        const localeOpen = Boolean(this.localeDialog?.open);
        this.classList.toggle('is-locale-open', localeOpen);
        this.localeTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', localeOpen ? 'true' : 'false'));
      }

      onSearchInput(event) {
        const input = event.currentTarget;
        this.lastSearchInput = input;
        this.syncSearchQuery(input);
        this.openSearch(input, false);
        this.queuePredictiveSearch(input.value);
      }

      onSearchFocus(event) {
        if (this.ignoreNextSearchFocus) {
          this.ignoreNextSearchFocus = false;
          return;
        }
        const input = event.currentTarget;
        this.openSearch(input, false);
        if (input.value.trim()) this.queuePredictiveSearch(input.value);
      }

      onSearchSubmitClick(event) {
        if (this.isSearchOpen()) return;
        event.preventDefault();
        const form = event.currentTarget.closest('[data-giesto-header-search-form]');
        const input = form?.querySelector('[data-giesto-header-search-input]');
        this.openSearch(input, true);
      }

      onSearchSubmit(event) {
        const input = event.currentTarget.querySelector('[data-giesto-header-search-input]');
        if (input?.value.trim()) return;
        event.preventDefault();
        this.openSearch(input, true);
      }

      onSearchClear(event) {
        const form = event.currentTarget?.closest('[data-giesto-header-search-form]');
        const input = form?.querySelector('[data-giesto-header-search-input]');
        if (!input) return;

        input.value = '';
        this.lastSearchInput = input;
        this.syncSearchQuery(input);
        this.resetPredictiveSearch();
        this.ignoreNextSearchFocus = true;
        input.focus({ preventScroll: true });
      }

      onSearchClose() {
        this.closeSearch(true);
      }

      onSearchLink() {
        this.closeSearch(false);
      }

      isSearchOpen() {
        return Boolean(this.searchPanel && !this.searchPanel.hidden);
      }

      openSearch(input, shouldFocus) {
        if (!this.searchPanel) return;

        this.closeMega(false);
        this.closeDrawer(false);
        this.lastSearchInput = input || this.lastSearchInput || this.searchInputs[0] || null;
        this.searchPanel.hidden = false;
        if (!this.lastSearchInput?.value.trim()) this.resetPredictiveSearch();
        this.syncSearchState();

        if (shouldFocus && this.lastSearchInput) {
          window.requestAnimationFrame(() => {
            this.lastSearchInput?.focus({ preventScroll: true });
          });
        }
      }

      closeSearch(returnFocus) {
        const input = this.lastSearchInput || this.searchInputs[0] || null;
        if (this.searchPanel) this.searchPanel.hidden = true;
        this.resetPredictiveSearch();
        this.searchInputs.forEach((searchInput) => {
          searchInput.value = '';
        });
        this.syncSearchState();
        if (returnFocus && input && document.activeElement !== input) {
          this.ignoreNextSearchFocus = true;
          input.focus({ preventScroll: true });
        }
      }

      resetSearchState() {
        if (this.searchPanel) this.searchPanel.hidden = true;
        this.resetPredictiveSearch();
        this.lastSearchInput = null;
        this.ignoreNextSearchFocus = false;
        this.syncSearchState();
      }

      syncSearchState() {
        const searchOpen = this.isSearchOpen();
        this.classList.toggle('is-search-open', searchOpen);
        this.searchInputs?.forEach((input) => input.setAttribute('aria-expanded', searchOpen ? 'true' : 'false'));
        this.syncSearchClearButtons();
      }

      syncSearchQuery(source) {
        this.searchInputs.forEach((input) => {
          if (input !== source) input.value = source.value;
        });
        this.syncSearchClearButtons();
      }

      syncSearchClearButtons() {
        this.searchClearButtons?.forEach((button) => {
          const input = button.closest('[data-giesto-header-search-form]')?.querySelector('[data-giesto-header-search-input]');
          button.hidden = !input?.value.trim();
        });
      }

      queuePredictiveSearch(value) {
        const query = value.trim();

        if (!query) {
          this.resetPredictiveSearch();
          return;
        }

        if (!this.searchDynamicProducts || !this.searchDynamicResults || !this.predictiveSearchUrl || !this.predictiveSearchSection) {
          return;
        }

        if (this.searchRequestTimer) window.clearTimeout(this.searchRequestTimer);
        this.searchRequestController?.abort();
        this.searchRequestSequence += 1;

        const requestSequence = this.searchRequestSequence;
        this.searchStaticProducts?.setAttribute('hidden', '');
        this.searchDynamicProducts.hidden = false;
        this.searchDynamicProducts.setAttribute('aria-busy', 'true');
        this.searchDynamicResults.setAttribute('aria-busy', 'true');
        this.searchDynamicResults.replaceChildren();

        this.searchRequestTimer = window.setTimeout(() => {
          this.fetchPredictiveSearch(query, requestSequence);
        }, 220);
      }

      async fetchPredictiveSearch(query, requestSequence) {
        this.searchRequestTimer = null;
        const controller = new AbortController();
        this.searchRequestController = controller;

        try {
          const url = new URL(this.predictiveSearchUrl, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '4');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('resources[options][prefix]', 'last');
          url.searchParams.set('resources[options][unavailable_products]', 'hide');
          url.searchParams.set('section_id', this.predictiveSearchSection);

          const response = await fetch(url, {
            signal: controller.signal,
            headers: { Accept: 'text/html' },
          });

          if (!response.ok) throw new Error(`Predictive search request failed: ${response.status}`);

          const markup = await response.text();
          if (controller.signal.aborted || requestSequence !== this.searchRequestSequence) return;

          const documentMarkup = new DOMParser().parseFromString(markup, 'text/html');
          const cards = documentMarkup.querySelector('[data-giesto-header-predictive-cards]');

          if (cards?.dataset.predictiveSearchState === 'empty') {
            const fuzzyProducts = await this.getFuzzySearchProducts(query);
            if (controller.signal.aborted || requestSequence !== this.searchRequestSequence) return;

            if (fuzzyProducts.length) {
              this.renderFuzzySearchResults(query, fuzzyProducts);
            } else {
              this.searchDynamicResults.replaceChildren(cards.cloneNode(true));
            }
          } else if (cards) {
            this.searchDynamicResults.replaceChildren(cards.cloneNode(true));
          } else {
            this.renderPredictiveSearchEmptyState();
          }
        } catch (error) {
          if (controller.signal.aborted || requestSequence !== this.searchRequestSequence) return;
          const fuzzyProducts = await this.getFuzzySearchProducts(query);
          if (requestSequence !== this.searchRequestSequence) return;

          if (fuzzyProducts.length) {
            this.renderFuzzySearchResults(query, fuzzyProducts);
          } else {
            this.renderPredictiveSearchEmptyState();
          }
        } finally {
          if (requestSequence === this.searchRequestSequence) {
            this.searchDynamicProducts?.setAttribute('aria-busy', 'false');
            this.searchDynamicResults?.setAttribute('aria-busy', 'false');
            this.searchRequestController = null;
          }
        }
      }

      renderPredictiveSearchEmptyState() {
        if (!this.searchDynamicResults) return;
        const message = document.createElement('p');
        message.className = 'giesto-header__search-no-results';
        message.textContent = this.dataset.giestoHeaderSearchNoResults || '';
        this.searchDynamicResults.replaceChildren(message);
      }

      async getFuzzySearchProducts(query) {
        const normalizedQuery = this.normalizeSearchText(query);
        const queryTokens = normalizedQuery.split(' ').filter((token) => token.length >= 2);

        if (!queryTokens.length || !this.searchCatalogUrl) return [];

        const products = await this.getSearchCatalogProducts();
        if (!products.length) return [];

        return products
          .filter((product) => this.isSearchCatalogProductAvailable(product))
          .map((product, index) => ({
            product,
            index,
            score: this.getFuzzyProductScore(product, queryTokens),
          }))
          .filter(({ score }) => score > 0)
          .sort((first, second) => second.score - first.score || first.index - second.index)
          .slice(0, 4)
          .map(({ product }) => product);
      }

      async getSearchCatalogProducts() {
        if (Array.isArray(this.searchCatalogProducts)) return this.searchCatalogProducts;
        if (!this.searchCatalogUrl) return [];

        if (!this.searchCatalogRequest) {
          this.searchCatalogRequest = fetch(this.searchCatalogUrl, {
            headers: { Accept: 'application/json' },
          })
            .then((response) => (response.ok ? response.json() : null))
            .then((payload) => {
              const products = Array.isArray(payload?.products) ? payload.products : [];
              this.searchCatalogProducts = products;
              return products;
            })
            .catch(() => {
              this.searchCatalogRequest = null;
              this.searchCatalogProducts = null;
              return [];
            });
        }

        return this.searchCatalogRequest;
      }

      isSearchCatalogProductAvailable(product) {
        if (product?.available === false) return false;

        const variants = Array.isArray(product?.variants) ? product.variants : [];
        return !variants.length || variants.some((variant) => variant?.available !== false);
      }

      normalizeSearchText(value) {
        return String(value || '')
          .toLocaleLowerCase('tr-TR')
          .replace(/ı/g, 'i')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, ' ')
          .trim();
      }

      getFuzzyProductScore(product, queryTokens) {
        const variants = Array.isArray(product?.variants) ? product.variants : [];
        const tags = Array.isArray(product?.tags) ? product.tags.join(' ') : product?.tags;
        const searchableFields = [
          { value: product?.title, weight: 400 },
          { value: product?.product_type, weight: 280 },
          { value: variants.map((variant) => variant?.title).join(' '), weight: 240 },
          { value: tags, weight: 140 },
        ];

        let totalScore = 0;

        for (const queryToken of queryTokens) {
          let tokenScore = 0;

          for (const field of searchableFields) {
            const productTokens = this.normalizeSearchText(field.value).split(' ').filter(Boolean);

            for (const productToken of productTokens) {
              if (productToken.startsWith(queryToken)) {
                tokenScore = Math.max(tokenScore, field.weight + 40 + queryToken.length);
                continue;
              }

              if (queryToken.length >= 3 && productToken.includes(queryToken)) {
                tokenScore = Math.max(tokenScore, field.weight + 20 + queryToken.length);
                continue;
              }

              if (productToken[0] !== queryToken[0] || productToken.length < queryToken.length) continue;

              const productPrefix = productToken.slice(0, queryToken.length);
              const distance = this.getSearchEditDistance(queryToken, productPrefix);
              if (distance <= 1) tokenScore = Math.max(tokenScore, field.weight - 20 * distance + queryToken.length);
            }
          }

          if (!tokenScore) return 0;
          totalScore += tokenScore;
        }

        return totalScore;
      }

      getSearchEditDistance(firstValue, secondValue) {
        let beforePrevious = null;
        let previous = Array.from({ length: secondValue.length + 1 }, (_, index) => index);

        for (let firstIndex = 1; firstIndex <= firstValue.length; firstIndex += 1) {
          const current = [firstIndex];

          for (let secondIndex = 1; secondIndex <= secondValue.length; secondIndex += 1) {
            const cost = firstValue[firstIndex - 1] === secondValue[secondIndex - 1] ? 0 : 1;
            let distance = Math.min(
              previous[secondIndex] + 1,
              current[secondIndex - 1] + 1,
              previous[secondIndex - 1] + cost,
            );

            if (
              firstIndex > 1
              && secondIndex > 1
              && firstValue[firstIndex - 1] === secondValue[secondIndex - 2]
              && firstValue[firstIndex - 2] === secondValue[secondIndex - 1]
            ) {
              distance = Math.min(distance, beforePrevious[secondIndex - 2] + 1);
            }

            current[secondIndex] = distance;
          }

          beforePrevious = previous;
          previous = current;
        }

        return previous[secondValue.length];
      }

      renderFuzzySearchResults(query, products) {
        if (!this.searchDynamicResults) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'giesto-header__search-fuzzy-results';
        const message = document.createElement('p');
        message.className = 'giesto-header__search-fuzzy-message';
        message.setAttribute('role', 'status');
        message.textContent = this.searchFuzzyLabel || 'Benzer ürünler';

        const grid = document.createElement('div');
        grid.className = 'giesto-header__search-product-grid giesto-header__search-product-grid--predictive';
        grid.setAttribute('role', 'list');

        products.forEach((product) => {
          const card = document.createElement('a');
          const imageSource = typeof product.featured_image === 'string'
            ? product.featured_image
            : product.featured_image?.src || product.images?.[0]?.src || '';

          card.className = 'giesto-header__search-product';
          card.href = product.url || `${this.searchProductsUrl}${encodeURIComponent(product.handle || '')}`;
          card.setAttribute('aria-label', product.title || query);
          card.setAttribute('data-giesto-header-search-link', '');

          const media = document.createElement('span');
          media.className = 'giesto-header__search-product-media';
          media.setAttribute('aria-hidden', 'true');

          if (imageSource) {
            const image = document.createElement('img');
            image.className = 'giesto-header__search-product-image';
            image.src = imageSource;
            image.alt = '';
            image.loading = 'lazy';
            image.decoding = 'async';
            media.append(image);
          }

          card.append(media);
          grid.append(card);
        });

        wrapper.append(message, grid);
        this.searchDynamicResults.replaceChildren(wrapper);
      }

      resetPredictiveSearch() {
        if (this.searchRequestTimer) window.clearTimeout(this.searchRequestTimer);
        this.searchRequestTimer = null;
        this.searchRequestController?.abort();
        this.searchRequestController = null;
        this.searchRequestSequence += 1;
        this.searchStaticProducts?.removeAttribute('hidden');
        if (this.searchDynamicProducts) {
          this.searchDynamicProducts.hidden = true;
          this.searchDynamicProducts.setAttribute('aria-busy', 'false');
        }
        this.searchDynamicResults?.replaceChildren();
      }

      onOpenTrigger(event) {
        if (this.isDesktop()) return;
        event.preventDefault();
        const trigger = event.currentTarget;
        const panel = trigger.dataset.giestoHeaderPanel || 'all';

        if (!this.drawer) return;

        if (this.drawer.open && this.activeTrigger === trigger) {
          this.closeDrawer(true);
          return;
        }

        this.closeSearch(false);
        this.closeMega(false);
        this.lastTrigger = trigger;
        this.activeTrigger = trigger;
        this.setActivePanel(panel);
        this.resetMobilePanelState();

        if (!this.drawer.open) {
          try {
            this.drawer.show();
          } catch (error) {
            this.resetDrawerState();
            return;
          }
        }
        this.syncHeaderState();

        window.requestAnimationFrame(() => {
          const firstMenuItem = this.mobilePanels
            ?.find((mobilePanel) => mobilePanel.dataset.giestoHeaderMobilePanel === 'root')
            ?.querySelector('[data-giesto-header-mobile-open], a[href]');
          (firstMenuItem || trigger).focus({ preventScroll: true });
        });
      }

      onMobilePanelTrigger(event) {
        if (this.isDesktop()) return;
        event.preventDefault();
        this.setMobilePanel(event.currentTarget?.dataset.giestoHeaderMobileOpen, true);
      }

      onMobileBack(event) {
        if (this.isDesktop()) return;
        event.preventDefault();
        this.setMobilePanel(event.currentTarget?.dataset.giestoHeaderMobileBack, true);
      }

      onMegaTrigger(event) {
        if (!this.isDesktop()) return;

        const trigger = event.currentTarget;

        // With a hovering pointer the panel is already open by the time the
        // click lands, so the click belongs to the link and navigates. Without
        // hover - touch on a wide screen - the click is the only way into the
        // panel, so it keeps opening it instead.
        if (trigger instanceof HTMLAnchorElement && trigger.href && this.hoverMedia.matches) return;

        event.preventDefault();

        if (!this.mega.hidden && this.activeMegaTrigger === trigger) {
          this.closeMega(true);
          return;
        }

        this.openMega(trigger);
      }

      onMegaPointerEnter(event) {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        this.clearMegaCloseTimer();
        this.openMega(event.currentTarget);
      }

      /**
       * Keyboard route into the panel. Enter on a link now navigates, so focus
       * has to be what opens it. Gated on :focus-visible so a mouse click does
       * not flash the panel open on its way to the destination.
       */
      onMegaTriggerFocus(event) {
        if (!this.isDesktop()) return;

        const trigger = event.currentTarget;
        if (!(trigger instanceof HTMLElement) || !trigger.matches(':focus-visible')) return;

        this.clearMegaCloseTimer();
        this.openMega(trigger);
      }

      onMegaPointerLeave() {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        this.queueMegaClose();
      }

      onPrimaryPlainLinkPointerEnter(event) {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        this.clearMegaCloseTimer();
        this.primaryPlainLinkPointer = event.currentTarget;
        if (!this.mega?.hidden) this.closeMega(false);
        this.syncPrimaryPlainLinkInteraction();
      }

      onPrimaryPlainLinkPointerLeave(event) {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        if (this.primaryPlainLinkPointer !== event.currentTarget) return;
        this.primaryPlainLinkPointer = null;
        this.syncPrimaryPlainLinkInteraction();
      }

      onPrimaryPlainLinkFocus(event) {
        if (!this.isDesktop()) return;
        this.primaryPlainLinkFocus = event.currentTarget;
        this.syncPrimaryPlainLinkInteraction();
      }

      onPrimaryPlainLinkBlur(event) {
        if (this.primaryPlainLinkFocus !== event.currentTarget) return;
        this.primaryPlainLinkFocus = null;
        this.syncPrimaryPlainLinkInteraction();
      }

      syncPrimaryPlainLinkInteraction() {
        const activeLink = this.primaryPlainLinkPointer || this.primaryPlainLinkFocus;
        this.classList.toggle('is-primary-link-interacting', Boolean(activeLink));
        this.primaryPlainLinks?.forEach((link) => {
          link.classList.toggle('is-primary-link-interacting', link === activeLink);
        });
      }

      clearPrimaryPlainLinkInteraction() {
        this.primaryPlainLinkPointer = null;
        this.primaryPlainLinkFocus = null;
        this.syncPrimaryPlainLinkInteraction();
      }

      onMegaSurfacePointerEnter() {
        this.clearMegaCloseTimer();
      }

      onMegaSurfacePointerLeave() {
        if (!this.isDesktop() || !this.hoverMedia.matches) return;
        this.queueMegaClose();
      }

      onMegaCategoryTrigger(event) {
        if (!this.isDesktop()) return;
        this.clearMegaCloseTimer();
        this.setActiveMegaCategory(event.currentTarget);
      }

      onMegaClose() {
        this.closeMega(true);
      }

      openMega(trigger) {
        const panel = trigger?.dataset.giestoHeaderMegaPanel;
        if (!panel || !this.mega) return;

        this.clearMegaCloseTimer();
        this.lastMegaTrigger = trigger;
        this.activeMegaTrigger = trigger;
        this.setSelectedMegaTrigger(trigger);
        this.setActiveMegaPanel(panel);
        this.mega.hidden = false;
        this.syncMegaState();
      }

      queueMegaClose() {
        this.clearMegaCloseTimer();
        this.megaCloseTimer = window.setTimeout(() => {
          this.megaCloseTimer = null;
          this.closeMega(false);
        }, 260);
      }

      clearMegaCloseTimer() {
        if (this.megaCloseTimer === null) return;
        window.clearTimeout(this.megaCloseTimer);
        this.megaCloseTimer = null;
      }

      onMegaLink() {
        this.closeMega(false);
      }

      onDocumentPointerDown(event) {
        const target = event.target;
        if (!(target instanceof Node)) return;

        if (this.isSearchOpen() && !this.contains(target)) {
          this.closeSearch(false);
        }

        if (!this.isDesktop() || this.mega?.hidden) return;

        const hitMega = this.mega?.contains(target);
        const hitTrigger = this.megaTriggers.some((trigger) => trigger.contains(target));

        if (!hitMega && !hitTrigger) this.closeMega(false);
      }

      onBreakpointChange() {
        this.resetMegaState();
        this.resetDrawerState();
        this.resetMobilePanelState();
        this.resetSearchState();
      }

      onCloseTrigger() {
        this.closeDrawer(true);
      }

      onCloseLink() {
        this.closeDrawer(false);
      }

      onDrawerClose() {
        const returnFocus = this.drawer?.dataset.giestoHeaderReturnFocus !== 'false';
        if (this.drawer) delete this.drawer.dataset.giestoHeaderReturnFocus;
        const trigger = this.lastTrigger;
        this.activeTrigger = null;
        this.resetMobilePanelState();
        if (this.backdrop) this.backdrop.hidden = true;
        this.syncHeaderState();
        if (returnFocus) trigger?.focus({ preventScroll: true });
      }

      onDrawerCancel() {
        if (this.drawer) this.drawer.dataset.giestoHeaderReturnFocus = 'true';
      }

      onDrawerClick(event) {
        if (event.target === this.drawer) this.closeDrawer(true);
      }

      onKeydown(event) {
        if (event.key !== 'Escape') return;

        if (this.localeDialog?.open) {
          event.preventDefault();
          this.closeLocaleDialog(true);
          return;
        }

        if (this.isSearchOpen()) {
          event.preventDefault();
          this.closeSearch(true);
          return;
        }

        if (this.isDesktop() && !this.mega?.hidden) {
          event.preventDefault();
          this.closeMega(true);
          return;
        }

        if (this.drawer?.open) {
          event.preventDefault();
          this.closeDrawer(true);
        }
      }

      onPageHide() {
        this.resetDrawerState();
        this.resetMegaState();
        this.resetMobilePanelState();
        this.resetSearchState();
        this.resetLocaleState();
      }

      onPageShow() {
        this.resetDrawerState();
        this.resetMegaState();
        this.resetMobilePanelState();
        this.resetSearchState();
        this.resetLocaleState();
      }

      onCartDrawerState(event) {
        if (event.target?.id !== 'cart-drawer') return;
        if (event.type === 'theme-drawer:open') {
          this.closeMega(false);
          this.closeDrawer(false);
          this.closeSearch(false);
          this.closeLocaleDialog(false);
        }
        this.syncCartDrawerState();
      }

      setActivePanel(panel) {
        if (!this.drawer) return;
        this.drawer.dataset.activePanel = panel;
        this.drawerPanels.forEach((drawerPanel) => {
          drawerPanel.hidden = panel !== 'all' && drawerPanel.dataset.giestoHeaderDrawerPanel !== panel;
        });
      }

      setActiveMegaPanel(panel) {
        if (!this.mega) return;
        this.mega.dataset.activePanel = panel;
        this.megaPanels.forEach((megaPanel) => {
          megaPanel.hidden = megaPanel.dataset.giestoHeaderMegaPanel !== panel;
          if (!megaPanel.hidden) this.resetMegaCategory(megaPanel);
        });
      }

      setSelectedMegaTrigger(trigger) {
        if (!this.primaryTriggers?.length || !trigger) return;

        this.primaryTriggers.forEach((candidate) => {
          candidate.classList.toggle('is-mega-selected', candidate === trigger);
        });
      }

      setActiveMegaCategory(trigger) {
        const megaPanel = trigger?.closest('[data-giesto-header-mega-panel]');
        const categoryId = trigger?.dataset.giestoHeaderMegaCategory;
        if (!megaPanel || !categoryId) return;

        this.megaCategoryTriggers.forEach((candidate) => {
          if (candidate.closest('[data-giesto-header-mega-panel]') !== megaPanel) return;
          candidate.classList.toggle('is-active', candidate === trigger);
        });

        this.megaCategoryPanels.forEach((categoryPanel) => {
          if (categoryPanel.closest('[data-giesto-header-mega-panel]') !== megaPanel) return;
          categoryPanel.hidden = categoryPanel.dataset.giestoHeaderMegaCategoryPanel !== categoryId;
        });
      }

      resetMegaCategory(megaPanel) {
        const defaultCategoryId = megaPanel?.dataset.giestoHeaderMegaDefaultCategory;
        if (!defaultCategoryId) return;

        this.megaCategoryTriggers.forEach((trigger) => {
          if (trigger.closest('[data-giesto-header-mega-panel]') === megaPanel) {
            trigger.classList.toggle('is-active', trigger.dataset.giestoHeaderMegaCategory === defaultCategoryId);
          }
        });

        this.megaCategoryPanels.forEach((categoryPanel) => {
          if (categoryPanel.closest('[data-giesto-header-mega-panel]') === megaPanel) {
            categoryPanel.hidden = categoryPanel.dataset.giestoHeaderMegaCategoryPanel !== defaultCategoryId;
          }
        });
      }

      setMobilePanel(panelId, moveFocus = false) {
        if (!panelId || !this.mobilePanels?.length) return;

        const nextPanel = this.mobilePanels.find(
          (mobilePanel) => mobilePanel.dataset.giestoHeaderMobilePanel === panelId,
        );
        if (!nextPanel) return;

        this.mobilePanels.forEach((mobilePanel) => {
          mobilePanel.hidden = mobilePanel !== nextPanel;
        });

        this.mobilePanelTriggers?.forEach((trigger) => {
          trigger.setAttribute(
            'aria-expanded',
            trigger.dataset.giestoHeaderMobileOpen === panelId ? 'true' : 'false',
          );
        });

        if (this.drawer) this.drawer.dataset.giestoHeaderMobilePanel = panelId;

        if (!moveFocus) return;
        window.requestAnimationFrame(() => {
          const focusTarget = nextPanel.querySelector(
            '[data-giesto-header-mobile-back], [data-giesto-header-mobile-open], a[href]',
          );
          focusTarget?.focus({ preventScroll: true });
        });
      }

      resetMobilePanelState() {
        this.setMobilePanel('root');
      }

      closeMega(returnFocus) {
        this.clearMegaCloseTimer();
        if (!this.mega || this.mega.hidden) {
          this.resetMegaState();
          return;
        }

        const trigger = this.lastMegaTrigger;
        this.mega.hidden = true;
        this.activeMegaTrigger = null;
        this.syncMegaState();
        if (returnFocus) trigger?.focus({ preventScroll: true });
      }

      resetMegaState() {
        this.clearMegaCloseTimer();
        if (!this.mega) return;
        this.clearPrimaryPlainLinkInteraction();
        this.mega.hidden = true;
        this.mega.setAttribute('aria-hidden', 'true');
        this.activeMegaTrigger = null;
        this.lastMegaTrigger = null;
        this.setSelectedMegaTrigger(this.defaultMegaTrigger);
        this.classList.remove('is-mega-open');
        this.megaTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.megaPanels?.forEach((megaPanel, index) => {
          megaPanel.hidden = index !== 0;
          this.resetMegaCategory(megaPanel);
        });
      }

      syncMegaState() {
        const megaOpen = Boolean(this.isDesktop() && this.mega && !this.mega.hidden);
        this.classList.toggle('is-mega-open', megaOpen);
        if (this.mega) this.mega.setAttribute('aria-hidden', megaOpen ? 'false' : 'true');
        this.megaTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', megaOpen && trigger === this.activeMegaTrigger ? 'true' : 'false');
        });
      }

      closeDrawer(returnFocus) {
        if (!this.drawer?.open) {
          this.resetDrawerState();
          return;
        }
        this.drawer.dataset.giestoHeaderReturnFocus = returnFocus ? 'true' : 'false';
        this.drawer.close();
      }

      resetDrawerState() {
        if (this.drawer?.open) {
          this.drawer.dataset.giestoHeaderReturnFocus = 'false';
          this.drawer.close();
        }

        this.drawer?.removeAttribute('open');
        if (this.backdrop) this.backdrop.hidden = true;
        this.activeTrigger = null;
        this.lastTrigger = null;
        this.resetMobilePanelState();
        this.classList.remove('is-menu-open');
        this.openTriggers?.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        this.syncHeaderState();
      }

      syncHeaderState() {
        const drawerOpen = Boolean(this.drawer?.open);
        this.classList.toggle('is-menu-open', drawerOpen);
        if (this.backdrop) this.backdrop.hidden = !drawerOpen;
        this.syncDocumentScrollLock();
        this.openTriggers?.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', drawerOpen && trigger === this.activeTrigger ? 'true' : 'false');
          const label = drawerOpen ? trigger.dataset.giestoHeaderCloseLabel : trigger.dataset.giestoHeaderMenuLabel;
          if (label) trigger.setAttribute('aria-label', label);
        });
      }

      syncDocumentScrollLock() {
        /*
         * This drawer is fixed below the sticky header and owns its own scroll
         * area. Locking html, body, or .page-wrapper would create a new sticky
         * containing block while the page is scrolled, which moves the header
         * out of view after the announcement bar has condensed.
         */
        document.documentElement.classList.remove('giesto-header-scroll-locked');
      }

      syncCartDrawerState() {
        const trigger = this.querySelector('[data-giesto-header-cart-trigger]');
        const drawer = document.getElementById('cart-drawer');
        if (trigger && drawer) trigger.setAttribute('aria-expanded', drawer.hasAttribute('open') ? 'true' : 'false');
      }
    }

    customElements.define('giesto-site-header', GiestoSiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-lookbook-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.GiestoLookbookCarousel) {
      const selector = '[data-giesto-lookbook-carousel]';

      const getBehavior = () => {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      };

      const setup = (root) => {
        if (!(root instanceof HTMLElement) || root._giestoLookbookCleanup) return;

        const track = root.querySelector('[data-giesto-lookbook-track]');
        if (!(track instanceof HTMLElement)) return;

        const controller = new AbortController();
        let dragState;
        let clickSuppressed = false;
        let suppressionTimer = 0;

        const getMaximum = () => Math.max(0, track.scrollWidth - track.clientWidth);

        const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

        const scrollByCard = (direction) => {
          const item = track.querySelector('.giesto-lookbook-carousel__item');
          const amount = item instanceof HTMLElement ? item.getBoundingClientRect().width : track.clientWidth;
          track.scrollBy({ left: direction * amount, behavior: getBehavior() });
        };

        const scrollToEdge = (position) => {
          track.scrollTo({ left: position, behavior: getBehavior() });
        };

        track.addEventListener(
          'wheel',
          (event) => {
            const horizontalIntent = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            const delta = horizontalIntent ? event.deltaX : event.shiftKey ? event.deltaY : 0;
            if (!delta) return;

            const nextPosition = clamp(track.scrollLeft + delta, 0, getMaximum());
            if (Math.abs(nextPosition - track.scrollLeft) < 0.5) return;

            event.preventDefault();
            track.scrollLeft = nextPosition;
          },
          { passive: false, signal: controller.signal }
        );

        const endDrag = (event) => {
          const activeDrag = dragState;
          if (!activeDrag) return;
          if (event && event.pointerId !== activeDrag.pointerId) return;

          dragState = undefined;
          track.removeAttribute('data-giesto-dragging');

          if (track.hasPointerCapture?.(activeDrag.pointerId)) {
            track.releasePointerCapture(activeDrag.pointerId);
          }

          if (activeDrag.moved) {
            clickSuppressed = true;
            window.clearTimeout(suppressionTimer);
            suppressionTimer = window.setTimeout(() => {
              clickSuppressed = false;
            }, 0);
          }
        };

        track.addEventListener(
          'pointerdown',
          (event) => {
            if (event.pointerType === 'touch' || event.button !== 0) return;
            if (event.target.closest?.('button, input, select, textarea')) return;

            dragState = {
              pointerId: event.pointerId,
              startX: event.clientX,
              startScrollLeft: track.scrollLeft,
              moved: false,
            };
            track.setPointerCapture?.(event.pointerId);
          },
          { signal: controller.signal }
        );

        track.addEventListener(
          'pointermove',
          (event) => {
            if (!dragState || event.pointerId !== dragState.pointerId) return;

            const distance = event.clientX - dragState.startX;
            if (!dragState.moved && Math.abs(distance) < 4) return;

            dragState.moved = true;
            track.dataset.giestoDragging = 'true';
            track.scrollLeft = clamp(dragState.startScrollLeft - distance, 0, getMaximum());
            event.preventDefault();
          },
          { passive: false, signal: controller.signal }
        );

        track.addEventListener('pointerup', endDrag, { signal: controller.signal });
        track.addEventListener('pointercancel', endDrag, { signal: controller.signal });
        track.addEventListener('lostpointercapture', endDrag, { signal: controller.signal });
        track.addEventListener('dragstart', (event) => event.preventDefault(), { signal: controller.signal });

        track.addEventListener(
          'click',
          (event) => {
            if (!clickSuppressed) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            clickSuppressed = false;
          },
          { capture: true, signal: controller.signal }
        );

        track.addEventListener(
          'keydown',
          (event) => {
            if (event.target !== track) return;

            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              scrollByCard(-1);
            }

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              scrollByCard(1);
            }

            if (event.key === 'Home') {
              event.preventDefault();
              scrollToEdge(0);
            }

            if (event.key === 'End') {
              event.preventDefault();
              scrollToEdge(getMaximum());
            }
          },
          { signal: controller.signal }
        );

        /* ---------- Autoplay ----------

           Advances one card at a time and wraps at the end, so the row visibly
           moves on its own - a static track gives no hint that it scrolls at
           all. Every tick is gated rather than the timer being torn down and
           rebuilt: one check every few seconds is cheaper than juggling timer
           state across five different pause conditions. */
        const autoplayInterval = Number(root.dataset.giestoAutoplay) || 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const hoverMedia = window.matchMedia('(hover: hover)');

        let autoplayTimer = 0;
        let autoplayObserver;
        let pointerInside = false;
        let focusInside = false;
        let onScreen = true;

        const canAutoplay = () =>
          autoplayInterval > 0
          && !reduceMotion.matches
          && !document.hidden
          && onScreen
          && !pointerInside
          && !focusInside
          && !dragState
          && getMaximum() > 1;

        const autoplayStep = () => {
          if (!canAutoplay()) return;

          const maximum = getMaximum();

          // 2px of slack: scrollLeft is fractional on zoomed and HiDPI layouts
          // and never lands exactly on the maximum, so an equality test would
          // leave the carousel stuck against the end.
          if (track.scrollLeft >= maximum - 2) {
            scrollToEdge(0);
            return;
          }

          scrollByCard(1);
        };

        if (autoplayInterval > 0) {
          autoplayTimer = window.setInterval(autoplayStep, autoplayInterval);

          // Hover only pauses where hovering is a real state; on touch a
          // pointerenter can arrive without a matching leave and would park the
          // carousel for good.
          root.addEventListener(
            'pointerenter',
            () => {
              if (hoverMedia.matches) pointerInside = true;
            },
            { signal: controller.signal }
          );
          root.addEventListener(
            'pointerleave',
            () => {
              pointerInside = false;
            },
            { signal: controller.signal }
          );

          root.addEventListener(
            'focusin',
            () => {
              focusInside = true;
            },
            { signal: controller.signal }
          );
          root.addEventListener(
            'focusout',
            () => {
              focusInside = false;
            },
            { signal: controller.signal }
          );

          if ('IntersectionObserver' in window) {
            autoplayObserver = new IntersectionObserver(
              (entries) => {
                onScreen = entries.some((entry) => entry.isIntersecting);
              },
              { threshold: 0.2 }
            );
            autoplayObserver.observe(root);
          }
        }

        root._giestoLookbookCleanup = () => {
          endDrag();
          controller.abort();
          window.clearTimeout(suppressionTimer);
          window.clearInterval(autoplayTimer);
          autoplayObserver?.disconnect();
          delete root._giestoLookbookCleanup;
        };
      };

      const initialise = (context = document) => {
        if (context instanceof HTMLElement && context.matches(selector)) setup(context);
        context.querySelectorAll?.(selector).forEach(setup);
      };

      const destroy = (context = document) => {
        if (context instanceof HTMLElement && context.matches(selector)) context._giestoLookbookCleanup?.();
        context.querySelectorAll?.(selector).forEach((root) => root._giestoLookbookCleanup?.());
      };

      window.GiestoLookbookCarousel = { initialise, destroy };

      document.addEventListener('shopify:section:load', (event) => initialise(event.target));
      document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
    }

    window.GiestoLookbookCarousel.initialise();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-basic-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-giesto-cookie-settings]') || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    window.privacyBanner.showPreferences();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-product"]) return;
  try {
    
  class GiestoStoreProduct extends HTMLElement {
    #controller = null;
    #gallery = null;
    #variants = [];
    #selected = [];
    #hasOptions = false;

    connectedCallback() {
      // The theme editor re-inserts a live section without minting a fresh
      // element, so connect must be safe to run twice in a row.
      this.disconnectedCallback();

      this.#controller = new AbortController();
      const { signal } = this.#controller;

      this.#variants = this.#readVariants();
      this.#selected = this.#readSelection();
      this.#hasOptions = this.querySelectorAll('[data-gap-option]').length > 0;
      this.#gallery = this.querySelector('[data-gap-gallery]');

      this.addEventListener('click', this.#onClick, { signal });
      this.addEventListener('click', this.#guardSize, { signal, capture: true });
      this.addEventListener('submit', this.#guardSize, { signal, capture: true });
      this.addEventListener('theme-drawer:open', this.#onAccordionDrawerOpen, { signal });
      this.addEventListener('theme-drawer:close', this.#onAccordionDrawerClose, { signal });
      this.#gallery?.addEventListener('scroll', this.#onGalleryScroll, { signal, passive: true });

      this.#setIndex(0);
      this.#render();
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#controller = null;
      this.#gallery = null;
    }

    get #isComingSoon() {
      return this.dataset.comingSoon === 'true';
    }

    #readVariants() {
      const node = this.querySelector('[data-gap-variants]');
      if (!node?.textContent) return [];

      try {
        const parsed = JSON.parse(node.textContent);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        // A malformed payload must not take the buy block down with it — the
        // server-rendered variant id in the hidden input still adds to cart.
        return [];
      }
    }

    /**
     * Reads the server-rendered selection into a value-per-option-position
     * array. It starts from the rendered variant's own options so positions
     * that render no buttons still hold a value, then lets the marked buttons
     * win — they are the ones the shopper can actually move.
     */
    #readSelection() {
      let selection = [];

      try {
        const parsed = JSON.parse(this.dataset.selectedOptions ?? '[]');
        if (Array.isArray(parsed)) selection = parsed.slice();
      } catch {
        /* fall back to whatever the buttons report */
      }

      for (const button of this.querySelectorAll('[data-gap-option][data-selected="true"]')) {
        const position = Number(button.dataset.optionPosition);
        if (!Number.isInteger(position) || position < 0) continue;

        selection[position] = button.dataset.optionValue ?? null;
      }

      return selection;
    }

    #guardSize = (event) => {
      if (!this.#hasOptions || this.#matchVariant() || this.#isComingSoon) return;
      if (event.type === 'click' && !event.target.closest('[ref="addToCartButton"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const sizes = this.querySelector('.gap__option');
      sizes?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sizes?.classList.add('gap__option--required');
      sizes?.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
    };

    #onClick = (event) => {
      // Element, not HTMLElement — a click landing on an inline <svg> child is
      // an SVGElement and an HTMLElement check would swallow it.
      const target = event.target;
      if (!(target instanceof Element)) return;

      const accordionTrigger = target.closest('[data-gap-accordion-trigger]');
      if (accordionTrigger instanceof HTMLButtonElement) {
        this.#openAccordionDrawer(accordionTrigger);
        return;
      }

      const dot = target.closest('[data-gap-dot]');
      if (dot) {
        this.#scrollToFrame(Number(dot.getAttribute('data-gap-dot')));
        return;
      }

      // The thumbnails are real in-page anchors so the rail still works with
      // JavaScript off. Left to the browser, though, following that hash calls
      // scrollIntoView on the frame, which scrolls EVERY scrollable ancestor -
      // the document included - so the page jumped down on every thumbnail
      // click. Handling it here scrolls only the media scroller.
      const thumb = target.closest('[data-gap-thumb]');
      if (thumb) {
        event.preventDefault();
        this.#showFrame(Number(thumb.getAttribute('data-gap-thumb')));
        return;
      }

      const option = target.closest('[data-gap-option]');
      if (!option || option.disabled) return;

      const position = Number(option.dataset.optionPosition);
      if (!Number.isInteger(position) || position < 0) return;

      this.#selected[position] = option.dataset.optionValue ?? null;
      this.querySelectorAll('.gap__option--required').forEach(row => row.classList.remove('gap__option--required'));
      this.#render();

      // Colours live in a disclosure; collapse it once a choice lands.
      option.closest('details[data-gap-colour]')?.removeAttribute('open');
    };

    /**
     * Opens a product-information drawer without relying on the declarative
     * action handler. Sections can arrive before the `theme-drawer` module is
     * upgraded in the Theme Editor, so this direct path retries once the
     * custom element definition is available.
     */
    #openAccordionDrawer(trigger) {
      const drawerId = trigger.getAttribute('aria-controls');
      if (!drawerId) return;

      const drawer = document.getElementById(drawerId);
      if (!(drawer instanceof HTMLElement)) return;

      trigger.focus({ preventScroll: true });

      const tryOpen = () => {
        customElements.upgrade(drawer);
        if (typeof drawer.open !== 'function') return false;

        drawer.open();
        return true;
      };

      if (tryOpen()) return;

      customElements.whenDefined('theme-drawer').then(() => {
        if (!document.contains(drawer)) return;
        tryOpen();
      });
    }

    #onAccordionDrawerOpen = (event) => {
      this.#syncAccordionTrigger(event.target, true);
    };

    #onAccordionDrawerClose = (event) => {
      this.#syncAccordionTrigger(event.target, false);
    };

    #syncAccordionTrigger(drawer, expanded) {
      if (!(drawer instanceof HTMLElement) || !drawer.matches('theme-drawer[data-gap-accordion-drawer]')) {
        return;
      }

      const trigger = this.querySelector(
        `[data-gap-accordion-trigger][aria-controls="${drawer.id}"]`
      );
      trigger?.setAttribute('aria-expanded', String(expanded));
    }

    #render() {
      if (!this.#hasOptions || this.#variants.length === 0) return;

      const variant = this.#matchVariant();
      this.#renderOptionStates();
      this.#renderColour();
      this.#renderPrice(variant);
      this.#renderForm(variant);
      this.#syncMedia(variant);
      // The sticky bar reads availability straight off this payload, so a
      // coming-soon product reports its variant as unavailable there too.
      const payloadVariant = this.#isComingSoon && variant ? { ...variant, available: false } : variant;

      this.dispatchEvent(
        new CustomEvent('giesto:variant-change', {
          bubbles: true,
          detail: {
            productId: this.dataset.productId,
            variant: payloadVariant,
            selectedOptions: [...this.#selected],
          },
        })
      );
    }

    #matchVariant() {
      return (
        this.#variants.find(
          (variant) =>
            Array.isArray(variant.options) &&
            variant.options.every((value, position) => this.#selected[position] === value)
        ) ?? null
      );
    }

    /**
     * A value is offerable when some available variant carries it alongside
     * everything else the shopper has already picked.
     */
    #isValueAvailable(position, value) {
      return this.#variants.some(
        (variant) =>
          variant.available &&
          Array.isArray(variant.options) &&
          variant.options[position] === value &&
          variant.options.every(
            (option, index) => index === position || this.#selected[index] == null || this.#selected[index] === option
          )
      );
    }

    #renderOptionStates() {
      for (const button of this.querySelectorAll('[data-gap-option]')) {
        const position = Number(button.dataset.optionPosition);
        if (!Number.isInteger(position) || position < 0) continue;

        const value = button.dataset.optionValue ?? '';
        const selected = this.#selected[position] === value;
        const available = this.#isValueAvailable(position, value);

        button.dataset.selected = String(selected);
        button.dataset.available = String(available);
        button.setAttribute('aria-checked', String(selected));

        // Struck-through values are not clickable, but the current selection
        // stays operable so a shopper can never be trapped on a dead cell.
        button.disabled = !available && !selected;
      }
    }

    #renderColour() {
      const position = Number(this.dataset.colourPosition);
      if (!Number.isInteger(position) || position < 0) return;

      const name = this.#selected[position];
      const label = this.querySelector('[data-gap-colour-name]');
      if (label && name) label.textContent = name;

      const swatch = this.querySelector('[data-gap-colour-swatch]');
      const source = this.querySelector(
        `[data-gap-option][data-option-position="${position}"][data-selected="true"]`
      );
      if (swatch instanceof HTMLElement && source instanceof HTMLElement) {
        swatch.style.background = source.dataset.swatchBackground || 'var(--gs-grey)';
      }
    }

    #renderPrice(variant) {
      if (!variant) return;

      const value = this.querySelector('[data-gap-price-value]');
      const compare = this.querySelector('[data-gap-price-compare]');
      const unitPrice = this.querySelector('[data-gap-unit-price]');
      if (unitPrice) unitPrice.innerHTML = variant.unit_price ?? '';
      const onSale = Boolean(variant.compare_at);

      // innerHTML, not textContent: the payload is the `money` filter's own
      // output, so any currency-app wrapper the shop's money_format adds
      // survives a variant switch. See the capture note in the Liquid above.
      if (value) {
        value.innerHTML = variant.price ?? '';
        value.classList.toggle('gap__price-value--sale', onSale);
      }

      if (compare) {
        compare.innerHTML = onSale ? variant.compare_at : '';
        compare.toggleAttribute('hidden', !onSale);
      }
    }

    /**
     * product-form-component reads input[name="id"] out of the DOM at submit
     * time, so writing the value here is all the wiring add-to-cart needs.
     */
    #renderForm(variant) {
      const input = this.querySelector('input[name="id"]');

      // A coming-soon product never opens for sale, so no resolved variant may
      // switch the button back on - the server rendered it off on purpose.
      const available = !this.#isComingSoon && (!variant || Boolean(variant.available));

      if (input instanceof HTMLInputElement) {
        input.value = variant ? String(variant.id) : '';
        input.disabled = !variant?.available || this.#isComingSoon;
      }

      const container = this.querySelector('add-to-cart-component');
      const button = this.querySelector('[ref="addToCartButton"]');

      if (container && typeof container.disable === 'function' && typeof container.enable === 'function') {
        if (available) {
          container.enable();
        } else {
          container.disable();
        }
      } else if (button instanceof HTMLButtonElement) {
        button.disabled = !available;
      }

      if (!button) return;

      // add-to-cart-button prints its label as a bare text node between the
      // icon and the burst markup, so swap the node rather than the innerHTML.
      const label = available ? this.dataset.labelAdd : this.dataset.labelSoldOut;
      const textNode = Array.from(button.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent?.trim()
      );
      if (textNode && label) textNode.textContent = label;
    }

    #syncMedia(variant) {
      const gallery = this.#gallery;
      if (!gallery || !variant?.media_id) return;

      const frame = gallery.querySelector(`[data-media-id="${variant.media_id}"]`);

      // Only the mobile carousel scrolls; the desktop column is a static stack
      // and moving it would yank the page out from under the shopper.
      if (!(frame instanceof HTMLElement) || gallery.scrollWidth <= gallery.clientWidth) return;

      gallery.scrollTo({ left: frame.offsetLeft, behavior: 'smooth' });
    }

    #onGalleryScroll = () => {
      const gallery = this.#gallery;
      if (!gallery || gallery.clientWidth === 0) return;

      // Desktop stacks the frames and scrolls vertically; mobile swipes
      // horizontally. Which one is live is a runtime fact, not a breakpoint
      // guess, so read it off the scroller.
      if (gallery.clientHeight > 0 && gallery.scrollHeight > gallery.clientHeight + 1) {
        this.#setThumbIndex(Math.round(gallery.scrollTop / gallery.clientHeight));
        return;
      }

      const step = gallery.children[1] ? gallery.children[1].offsetLeft - gallery.children[0].offsetLeft : gallery.clientWidth;
      this.#setIndex(Math.round(gallery.scrollLeft / step));
    };

    /** Scrolls the media scroller - and nothing else - to one frame. */
    #showFrame(index) {
      const gallery = this.#gallery;
      if (!gallery || !Number.isInteger(index) || index < 0) return;

      const frame = gallery.children[index];
      if (!(frame instanceof HTMLElement)) return;

      // Measured rather than read off offsetTop/offsetLeft: the frames are
      // position:relative but the scroller is not, so their offsetParent is
      // some ancestor further up and those offsets are not scroller-relative.
      const frameBox = frame.getBoundingClientRect();
      const galleryBox = gallery.getBoundingClientRect();

      if (gallery.scrollHeight > gallery.clientHeight + 1) {
        gallery.scrollTo({
          top: gallery.scrollTop + frameBox.top - galleryBox.top,
          behavior: 'smooth',
        });
      } else if (gallery.scrollWidth > gallery.clientWidth + 1) {
        gallery.scrollTo({
          left: gallery.scrollLeft + frameBox.left - galleryBox.left,
          behavior: 'smooth',
        });
      }

      this.#setThumbIndex(index);
    }

    #setThumbIndex(index) {
      for (const thumb of this.querySelectorAll('[data-gap-thumb]')) {
        const active = Number(thumb.getAttribute('data-gap-thumb')) === index;

        thumb.setAttribute('data-active', String(active));

        if (active) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      }
    }

    #setIndex(index) {
      const counter = this.querySelector('[data-gap-counter]');
      if (counter) counter.textContent = String(index + 1);

      for (const dot of this.querySelectorAll('[data-gap-dot]')) {
        const active = Number(dot.getAttribute('data-gap-dot')) === index;
        dot.setAttribute('data-active', String(active));
        dot.setAttribute('aria-current', String(active));
      }
    }

    #scrollToFrame(index) {
      const gallery = this.#gallery;
      if (!gallery || !Number.isInteger(index)) return;

      this.#showFrame(index);
      this.#setIndex(index);
    }
  }

  if (!customElements.get('giesto-store-product')) {
    customElements.define('giesto-store-product', GiestoStoreProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-recommendations"] && !Shopify.designMode) return;
  try {
    
  /**
   * A second load trigger for <product-recommendations>, against the right root.
   *
   * The theme's element (assets/product-recommendations.js) starts its fetch
   * from an IntersectionObserver with `root: null` and `rootMargin: 0 0 400px 0`.
   * On this theme the desktop scroll container is `.page-wrapper` — base.css
   * gives it `height: 100dvh; overflow-y: auto` at >= 990px — and an observer's
   * rootMargin does NOT expand an intermediate scroll clip. So on desktop the
   * rail gets no pre-load margin at all and only loads once it is genuinely on
   * screen; a layout shift while the PDP's own images settle can make it miss.
   *
   * Measured on the live preview, three runs each: 390px 3/3 loaded, 768px 3/3,
   * 1440px 2/3 — the failure left `performed=false` with the placeholder still
   * showing and no error.
   *
   * This observes the same element against `.page-wrapper` when that is the
   * scroller, and on intersection sets an attribute. Changing any attribute is
   * the element's own reload path (its MutationObserver reloads on attribute
   * changes), so nothing here reaches into the theme's file or duplicates its
   * fetch — and its `recommendationsPerformed` guard makes a double trigger a
   * no-op.
   */
  (() => {
    const SELECTOR = 'product-recommendations.gar';
    const armed = new WeakSet();

    /** The element that actually scrolls, or null for the document. */
    const scrollRoot = () => {
      const wrapper = document.querySelector('.page-wrapper');
      if (!wrapper) return null;

      const overflowY = getComputedStyle(wrapper).overflowY;
      const scrolls = overflowY === 'auto' || overflowY === 'scroll';
      return scrolls && wrapper.scrollHeight > wrapper.clientHeight ? wrapper : null;
    };

    const arm = (element) => {
      if (armed.has(element) || element.dataset.recommendationsPerformed === 'true') return;
      armed.add(element);

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          observer.disconnect();
          if (element.dataset.recommendationsPerformed === 'true') return;
          element.setAttribute('data-gar-visible', '1');
        },
        { root: scrollRoot(), rootMargin: '0px 0px 600px 0px' }
      );

      observer.observe(element);
    };

    const armAll = () => {
      for (const element of document.querySelectorAll(SELECTOR)) arm(element);
    };

    /* Arming before the element upgrades would fire the attribute change at
       nothing — its MutationObserver only starts in connectedCallback. */
    customElements.whenDefined('product-recommendations').then(() => {
      armAll();
      document.addEventListener('shopify:section:load', armAll);
    });
  })();

  /**
   * The rail's prev/next pair.
   *
   * Measured on the reference at 900px, where the row has room to move: one
   * click advances `scrollLeft` by exactly one cell plus the 1px gap (333 -> 334),
   * a second click clamps at the end (435 = scrollWidth - clientWidth) and
   * disables `next`. `prev` starts disabled and both stay in place, faded, at
   * their end — the pair never leaves the row.
   *
   * Everything is delegated rather than bound per element: the fetched branch
   * replaces the whole inner markup when <product-recommendations> resolves,
   * and `shopify:section:load` does not fire for that morph. Clicks delegate
   * off `document`; `scroll` does not bubble but does reach a capture-phase
   * listener there, which is what keeps the disabled state honest.
   */
  (() => {
    let drag = null;
    let suppressClickUntil = 0;

    const sync = (row) => {
      const nav = row.closest('.gar')?.querySelector('.gar__nav');
      if (!nav) return;

      /* Sub-pixel cell widths make the end land a fraction short of the
         arithmetic maximum, so compare with a pixel of slack. */
      const end = row.scrollWidth - row.clientWidth;
      for (const button of nav.querySelectorAll('.gar__nav-button')) {
        const forward = Number(button.dataset.garStep) > 0;
        button.disabled = forward ? row.scrollLeft >= end - 1 : row.scrollLeft <= 1;
      }
    };

    const syncAll = () => {
      for (const row of document.querySelectorAll('.gar__row')) sync(row);
    };

    document.addEventListener('click', (event) => {
      if (performance.now() < suppressClickUntil && event.target instanceof Element && event.target.closest('.gar__row')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { capture: true });

    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element && event.target.closest('.gar__nav-button');
      if (!button) return;

      const row = document.getElementById(button.getAttribute('aria-controls'));
      const cell = row?.querySelector('.gar__cell');
      if (!cell) return;

      const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      const step = (cell.getBoundingClientRect().width + gap) * Number(button.dataset.garStep);
      row.scrollBy({ left: step, behavior: 'smooth' });
    });

    /* Touch already uses native momentum scrolling. This gives a mouse the
       same direct left/right drag without turning a small movement into a
       product-card click. */
    document.addEventListener('pointerdown', (event) => {
      const row = event.target instanceof Element ? event.target.closest('.gar__row') : null;
      if (!row || event.pointerType !== 'mouse' || event.button !== 0) return;
      if (row.scrollWidth <= row.clientWidth + 2) return;
      if (event.target.closest('button,input,select,textarea,[role="button"]')) return;
      drag = { row, pointerId: event.pointerId, startX: event.clientX, startScroll: row.scrollLeft, moved: false };
      // A click must retain its original target (quick-add, heart or link).
      // Capture only once the pointer has actually started dragging.
    });

    document.addEventListener('pointermove', (event) => {
      if (!drag || event.pointerId !== drag.pointerId) return;
      const distance = event.clientX - drag.startX;
      if (!drag.moved && Math.abs(distance) < 5) return;
      if (!drag.moved) drag.row.setPointerCapture?.(event.pointerId);
      drag.moved = true;
      drag.row.classList.add('is-dragging');
      drag.row.scrollLeft = drag.startScroll - distance;
      event.preventDefault();
    }, { passive: false });

    const finishDrag = (event) => {
      if (!drag || event.pointerId !== drag.pointerId) return;
      const { row, moved, pointerId } = drag;
      row.classList.remove('is-dragging');
      if (row.hasPointerCapture?.(pointerId)) row.releasePointerCapture(pointerId);
      if (moved) suppressClickUntil = performance.now() + 250;
      drag = null;
      sync(row);
    };

    document.addEventListener('dragstart', (event) => {
      if (drag && event.target instanceof Element && event.target.closest('.gar__row') === drag.row) event.preventDefault();
    });

    document.addEventListener('pointerup', finishDrag);
    document.addEventListener('pointercancel', finishDrag);

    document.addEventListener(
      'scroll',
      (event) => {
        const row = event.target instanceof Element ? event.target.closest('.gar__row') : null;
        if (row) sync(row);
      },
      { capture: true, passive: true }
    );

    /* The row arrives after this script on the fetched branch, so watch each
       root for it rather than polling the whole document. Only childList is
       observed: `sync` writes `disabled`, and observing attributes here would
       feed that straight back in. */
    const watched = new WeakSet();
    const initialize = () => {
      for (const root of document.querySelectorAll('.gar')) {
        if (watched.has(root)) continue;
        watched.add(root);
        new MutationObserver(syncAll).observe(root, { childList: true, subtree: true });
      }
      syncAll();
    };

    /* The mock places curated combinations inside the PDP detail column while
       leaving automatic related products full-width below the product. The
       pairing section remains independently editable and simply mounts its
       rendered rail into the product section's declared slot. */
    const mountPairings = () => {
      const slot = document.querySelector('[data-gap-combine-slot]');
      if (!slot) return;
      for (const rail of document.querySelectorAll('.gar[data-gar-source="pairings"]')) {
        if (rail.parentElement === slot) continue;
        rail.classList.add('gar--inline-pairings');
        slot.append(rail);
      }
    };

    addEventListener('resize', syncAll, { passive: true });
    document.addEventListener('shopify:section:load', () => {
      mountPairings();
      initialize();
    });
    mountPairings();
    initialize();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-store-splash"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.GiestoSplashProducts) return;
    window.GiestoSplashProducts = true;

    const syncViewportLayout = () => {
      document.documentElement.classList.toggle('gs-splash-viewport', Boolean(document.querySelector('.giesto-splash[data-giesto-splash-viewport]')));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncViewportLayout, { once: true });
    else syncViewportLayout();
    for (const type of ['shopify:section:load', 'shopify:section:unload']) document.addEventListener(type, () => requestAnimationFrame(syncViewportLayout));

    const focusTargets = new WeakMap();
    const scrollStyles = new WeakMap();

    const restoreDialogState = (dialog, restoreFocus = true) => {
      if (!focusTargets.has(dialog)) return;
      const opener = focusTargets.get(dialog);
      document.body.style.overflowY = scrollStyles.get(dialog) || '';
      scrollStyles.delete(dialog);
      focusTargets.delete(dialog);
      opener.setAttribute('aria-expanded', 'false');
      if (restoreFocus && document.contains(opener)) opener.focus({ preventScroll: true });
    };

    const closeDialog = (dialog) => {
      if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
      dialog.close();
      // The native close event is queued. Finish this opening's cleanup now,
      // before another click can reopen the drawer and replace its saved state.
      restoreDialogState(dialog);
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const opener = target.closest('[data-giesto-splash-open]');
      if (opener instanceof HTMLButtonElement) {
        const dialogId = opener.getAttribute('aria-controls');
        const dialog = dialogId ? document.getElementById(dialogId) : null;
        if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

        event.preventDefault();
        // Also handle a native close followed by reopening before its event runs.
        restoreDialogState(dialog, false);
        const money = new Intl.NumberFormat(dialog.dataset.locale === 'tr' ? 'tr-TR' : 'en-GB', {
          style: 'currency', currency: dialog.dataset.currency || 'TRY',
        });
        dialog.querySelectorAll('[data-splash-money]').forEach(price => {
          const formatted = money.format(Number(price.dataset.splashMoney) / 100);
          if (price.textContent !== formatted) price.textContent = formatted;
        });
        focusTargets.set(dialog, opener);
        opener.setAttribute('aria-expanded', 'true');
        scrollStyles.set(dialog, document.body.style.overflowY);
        document.body.style.overflowY = 'hidden';
        opener.focus({ preventScroll: true });
        dialog.showModal();
        dialog.querySelector('[data-giesto-splash-close]')?.focus({ preventScroll: true });
        return;
      }

      const closeButton = target.closest('[data-giesto-splash-close]');
      if (closeButton instanceof HTMLButtonElement) {
        closeDialog(closeButton.closest('[data-giesto-splash-dialog]'));
        return;
      }

      if (target instanceof HTMLDialogElement && target.matches('[data-giesto-splash-dialog]')) {
        closeDialog(target);
      }
    });

    // Keep the product drawer behind its size picker until adding succeeds.
    document.addEventListener('shopify:cart:lines-update', event => {
      if (event.action !== 'add' || !(event.promise instanceof Promise)) return;
      const source = event.target instanceof Element ? event.target.closest('[data-giesto-splash-dialog]') : null;
      const dialog = source || (document.querySelector('#GiestoStoreSizePicker[data-splash][open]')
        ? document.querySelector('[data-giesto-splash-dialog][open]') : null);
      if (!dialog) return;
      event.promise.then(result => {
        if (!result?.detail?.didError) closeDialog(dialog);
      }).catch(() => {});
    });

    document.addEventListener('cancel', (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-giesto-splash-dialog]')) return;
      event.preventDefault();
      closeDialog(dialog);
    }, true);

    document.addEventListener('close', (event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.matches('[data-giesto-splash-dialog]')) return;
      // Ignore an old close event delivered after the same drawer reopened.
      if (!dialog.open) restoreDialogState(dialog);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giesto-wishlist"] && !Shopify.designMode) return;
  try {
    
  class GiestoWishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid=this.querySelector('[data-gwl-grid]');this.template=this.querySelector('[data-gwl-template]');
      this.previewGrid=this.querySelector('[data-gwl-preview-grid]');this.cards=[];
      this.empty=this.querySelector('[data-gwl-empty]');this.lead=this.querySelector('[data-gwl-lead]');
      this.counter=this.querySelector('[data-gwl-count]');this.view=this.querySelector('[data-gwl-view]');this.toolbar=this.querySelector('[data-gwl-toolbar]');
      this.loginShort=this.querySelector('[data-gwl-login-short]');this.removeLabel=this.dataset.removeLabel||'Remove';
      this.addLabel=this.dataset.addLabel||'Choose size';this.productCache=new Map();this.colourCache=new Map();this.render=this.render.bind(this);
      this.addEventListener('click',this.onClick);document.addEventListener('giesto:wishlist:change',this.render);
      if(window.GiestoWishlist)this.render();else window.addEventListener('DOMContentLoaded',this.render,{once:true});
    }
    disconnectedCallback(){document.removeEventListener('giesto:wishlist:change',this.render)}
    onClick=async(event)=>{
      const target=event.target instanceof Element?event.target:null;const viewButton=target?.closest('[data-gwl-columns]');
      if(viewButton){const columns=viewButton.dataset.gwlColumns;this.arrangeCards(columns);for(const button of this.querySelectorAll('[data-gwl-columns]'))button.setAttribute('aria-pressed',String(button===viewButton));try{localStorage.setItem('giesto:wishlist-columns',columns)}catch{}return}
      const galleryButton=target?.closest('[data-gwl-gallery]');
      if(galleryButton){event.preventDefault();event.stopPropagation();const track=galleryButton.closest('.gwl__media-shell')?.querySelector('[data-gwl-track]');if(track){track.scrollBy({left:Number(galleryButton.dataset.gwlGallery)*track.clientWidth,behavior:'smooth'})}return}
      const remove=target?.closest('[data-gwl-remove]');if(remove){const id=remove.closest('[data-id]')?.dataset.id;if(id)window.GiestoWishlist?.remove(id);return}
      const add=target?.closest('[data-gwl-add]');if(!(add instanceof HTMLButtonElement))return;event.preventDefault();event.stopPropagation();await this.openSizePicker(add);
    }
    async getProduct(item){
      if(this.productCache.has(item.id))return this.productCache.get(item.id);
      const path=new URL(item.url||`/products/${item.handle}`,location.origin).pathname.replace(/\/$/,'');
      const promise=(async()=>{
        let response=await fetch(`${path}.js`,{headers:{Accept:'application/json'}});
        // Shopify's local development proxy can lose its product-JSON session.
        // Only public catalog data is read from the store; no cookies are sent.
        if([401,403].includes(response.status)&&['localhost','127.0.0.1'].includes(location.hostname)&&this.dataset.catalogOrigin){
          response=await fetch(new URL(`${path}.js`,this.dataset.catalogOrigin),{credentials:'omit',headers:{Accept:'application/json'}});
        }
        return response.ok?response.json():null;
      })().catch(()=>null);
      this.productCache.set(item.id,promise);return promise;
    }
    getColourGroup(item){
      if(this.colourCache.has(item.id))return this.colourCache.get(item.id);
      const query=new URLSearchParams({shop:this.dataset.shop||'',product_id:String(item.id)});
      const promise=fetch(`/apps/renk-grubu/get-group?${query}`,{headers:{Accept:'application/json'}})
        .then(response=>response.ok?response.json():null).catch(()=>null);
      this.colourCache.set(item.id,promise);return promise;
    }
    showColour(cell,item,colour,background,extra){
      const row=cell.querySelector('[data-gwl-colour]');if(!row)return;
      row.href=item.url;row.title=colour;row.setAttribute('aria-label',`${item.title}: ${colour}${extra>0?` +${extra}`:''}`);
      row.querySelector('[data-gwl-swatch]').style.background=background;
      row.querySelector('[data-gwl-colour-count]').textContent=extra>0?`+${extra}`:'';row.hidden=false;
    }
    enrichColours(cell,item){
      if(cell.dataset.gwlColours)return;cell.dataset.gwlColours='pending';
      this.getColourGroup(item).then(source=>{
        if(!cell.isConnected){delete cell.dataset.gwlColours;return}
        if(!source?.success||!window.GiestoColorGroups)return;
        const group=window.GiestoColorGroups.match({dataset:{p:String(item.id),locale:this.dataset.locale}},source);
        const current=group.products.find(product=>String(product.id).replace('gid://shopify/Product/','')===String(item.id));
        if(!current?.colorCode)return;
        cell.dataset.gwlLinkedColour='true';cell.dataset.gwlColours='true';
        this.showColour(cell,item,current.color||'',current.colorCode,group.products.length-1);
      });
    }
    async openSizePicker(button){
      const cell=button.closest('[data-id]');const item=window.GiestoWishlist?.items.find(entry=>String(entry.id)===cell?.dataset.id);if(!item)return;
      button.disabled=true;const product=await this.getProduct(item);button.disabled=false;if(!product){location.href=item.url;return}
      const options=Array.isArray(product.options)?product.options:[];const colourNames=['color','colour','farbe','couleur','kleur','renk'];
      let sizePosition=options.findIndex(option=>!colourNames.includes(String(option?.name||option).toLowerCase()));if(sizePosition<0)sizePosition=0;
      let variants=cell.querySelector('[data-gac-variants]');if(!variants){variants=document.createElement('script');variants.type='application/json';variants.dataset.gacVariants='';cell.append(variants)}
      variants.textContent=JSON.stringify(product.variants||[]);button.dataset.productId=String(product.id||item.id);button.dataset.productUrl=item.url;
      button.dataset.productTitle=item.title;button.dataset.sizePosition=String(sizePosition);
      document.dispatchEvent(new CustomEvent('giesto:size-picker:open',{detail:{trigger:button,returnFocus:button}}));
    }
    enrichCard(cell,item){
      if(cell.dataset.gwlEnriched)return;cell.dataset.gwlEnriched='pending';
      this.getProduct(item).then(product=>{
        if(!product||!cell.isConnected){delete cell.dataset.gwlEnriched;return}cell.dataset.gwlEnriched='true';
        const track=cell.querySelector('[data-gwl-track]');const productMedia=Array.isArray(product.media)?product.media.filter(media=>media?.media_type==='image'):[];
        const images=productMedia.length?productMedia.map(media=>media.src||media.preview_image?.src):Array.isArray(product.images)?product.images:[];
        if(track&&images.length){const fragment=document.createDocumentFragment();images.forEach((source,index)=>{const slide=document.createElement('span');slide.className='gwl__slide';const image=document.createElement('img');image.className='gwl__image';image.src=String(source).startsWith('//')?`https:${source}`:source;image.alt=item.title;image.loading=index?'lazy':'eager';image.width=600;image.height=800;slide.append(image);fragment.append(slide)});track.replaceChildren(fragment);
          const previous=cell.querySelector('[data-gwl-gallery="-1"]');const next=cell.querySelector('[data-gwl-gallery="1"]');const update=()=>{const index=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));if(previous)previous.disabled=index<=0;if(next)next.disabled=index>=images.length-1};let frame=0;track.addEventListener('scroll',()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;update()})},{passive:true});if(previous)previous.hidden=images.length<2;if(next)next.hidden=images.length<2;update();
        }
        const names=['color','colour','farbe','couleur','kleur','renk'];const options=Array.isArray(product.options)?product.options:[];
        const colourOption=options.find(option=>names.includes(String(option?.name||'').toLowerCase()));const values=Array.isArray(colourOption?.values)?colourOption.values:[];
        if(!values.length||cell.dataset.gwlLinkedColour)return;
        const colour=String(values[0]||'').normalize('NFKD').replace(/\p{M}/gu,'').toLowerCase().replace(/ı/g,'i');
        const colours={black:'#202020',siyah:'#202020',white:'#f7f7f7',beyaz:'#f7f7f7',navy:'#173052',lacivert:'#173052',blue:'#477da8',mavi:'#477da8',brown:'#765039',kahverengi:'#765039',beige:'#d9c49c',bej:'#d9c49c',grey:'#9a9a9a',gray:'#9a9a9a',gri:'#9a9a9a',green:'#477b59',yeşil:'#477b59',red:'#bd3030',kırmızı:'#bd3030'};
        this.showColour(cell,item,String(values[0]),Object.entries(colours).find(([key])=>colour.includes(key))?.[1]||'#d8d8d8',values.length-1);
      });
    }
    arrangeCards(columns){
      this.grid.dataset.columns=columns;
      if(this.previewGrid){
      this.previewGrid.dataset.columns=columns;
      // ARKET's guest list exposes the first group and previews the next group
      // underneath an inert sign-in panel. The saved store retains every item.
      const limit=columns==='wide'?3:4;
      this.grid.replaceChildren(...this.cards.slice(0,limit));
      this.previewGrid.replaceChildren(...this.cards.slice(limit,limit*2));
      }
      for(const cell of this.cards){if(!cell.isConnected)continue;const item=window.GiestoWishlist?.items.find(item=>String(item.id)===cell.dataset.id);if(item){this.enrichCard(cell,item);this.enrichColours(cell,item)}}
    }
    render(){
      const store=window.GiestoWishlist;if(!store||!this.grid||!this.template)return;store.refresh?.();const items=store.items;this.grid.replaceChildren();
      this.cards=[];
      for(const item of items){const node=this.template.content.cloneNode(true);const cell=node.querySelector('.gwl__cell');const link=node.querySelector('[data-gwl-link]');
        const image=node.querySelector('[data-gwl-image]');const name=node.querySelector('[data-gwl-name]');const price=node.querySelector('[data-gwl-price]');
        const removes=node.querySelectorAll('[data-gwl-remove]');const addLabels=node.querySelectorAll('[data-gwl-add-label]');
        if(cell)cell.dataset.id=String(item.id);if(link)link.href=item.url;if(image){image.src=item.image;image.alt=item.title;if(!item.image)image.remove()}
        if(name){name.textContent=item.title;name.href=item.url}if(price)price.textContent=item.price;for(const remove of removes)remove.setAttribute('aria-label',`${this.removeLabel} ${item.title}`);
        for(const addLabel of addLabels)addLabel.textContent=`${this.addLabel}: ${item.title}`;this.grid.append(node);if(cell)this.cards.push(cell);
      }
      const hasItems=items.length>0;const becameEmpty=this.hadItems===true&&!hasItems;this.hadItems=hasItems;this.toggleAttribute('data-empty',!hasItems);
      this.empty.hidden=hasItems;this.lead.hidden=!hasItems;if(this.loginShort)this.loginShort.hidden=!hasItems;
      this.toolbar.hidden=!hasItems;this.grid.hidden=!hasItems;const unit=items.length===1?this.dataset.unitOne:this.dataset.unitOther;this.counter.textContent=`${items.length} ${unit}`;
      let columns='dense';try{if(localStorage.getItem('giesto:wishlist-columns')==='wide')columns='wide'}catch{}this.arrangeCards(columns);
      for(const button of this.querySelectorAll('[data-gwl-columns]'))button.setAttribute('aria-pressed',String(button.dataset.gwlColumns===columns));
      if(becameEmpty)requestAnimationFrame(()=>{if(document.scrollingElement)document.scrollingElement.scrollTop=0;scrollTo({top:0,behavior:'auto'})});
    }
  }
  if(!customElements.get('giesto-wishlist-page'))customElements.define('giesto-wishlist-page',GiestoWishlistPage);

  } catch(e) { console.error(e); }
})();
})();
